"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEssentialSession = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const react_1 = require("react");
const sc_cookies_1 = require("../lib/sc-cookies");
const web_env_1 = require("@snapchat/web-env");
const useEssentialSession = () => {
    (0, react_1.useEffect)(() => {
        const newCookieToSet = (0, sc_cookies_1.getNewEssentialSessionCookie)((0, web_env_1.getDocument)()?.cookie, (0, web_env_1.getDocument)()?.location.host);
        if (!newCookieToSet) {
            // essential session cookie is already present, don't need to set again
            return;
        }
        const { key, value, options } = newCookieToSet;
        js_cookie_1.default.set(key, value, options);
        // eslint-disable-next-line react-hooks/exhaustive-deps --- we only want the effect to run once, after mount
    }, []);
};
exports.useEssentialSession = useEssentialSession;
//# sourceMappingURL=essential-session.js.map